import type { Mission } from '../missions.ts'

export const doc: Mission = {
  id: "doc",
  name: "U.S. Department of Commerce",
  short: "DOC",
  call: "Commerce",
  kind: "department",
  url: "https://www.commerce.gov/",
  established: 1903,
  palette: {
    primary: "#00538e",
    secondary: "#0095d9",
    accent: "#f6ca43",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Commerce.svg",
  },
  motif: "lighthouse",
  mission: {
    text: "The Department of Commerce’s mission is to create the conditions for economic growth and opportunity for all communities.",
    url: "https://www.commerce.gov/about",
  },
  fact: {
    text: "Commerce was created as the Department of Commerce and Labor on February 14, 1903, and renamed on March 4, 1913.",
    url: "https://www.commerce.gov/about/history",
  },
  seal: {
    file: "public/seals/doc.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Commerce.svg",
  },
  identifier: {
    about: "https://www.commerce.gov/about",
    accessibility: "https://www.commerce.gov/about/policies/section-508-accessibility-statement",
    foia: "https://www.commerce.gov/opog/foia/foia-requests",
    noFear: "https://www.commerce.gov/cr/reports-and-resources/no-fear-act",
    oig: "https://www.oig.doc.gov/",
    performance: "https://www.commerce.gov/about/budget-and-performance",
    privacy: "https://www.commerce.gov/about/policies/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/doc-hoover-building.jpg",
        small: "/media/doc-hoover-building-sm.jpg",
        alt: "The limestone facade of the Herbert C. Hoover Building with arched entrances, iron lanterns and an American flag.",
        title: "Herbert C. Hoover Building, U.S. Department of Commerce, Washington, D.C.",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Herbert_C._Hoover_Building,_U.S._Department_of_Commerce,_Washington,_D.C_LCCN2010719583.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/doc-hoover-lobby.jpg",
        small: "/media/doc-hoover-lobby-sm.jpg",
        alt: "The marble main lobby of the Herbert C. Hoover Building, with columns, a coffered ceiling and chandeliers.",
        title: "Lobby, Herbert C. Hoover Building",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Lobby,_Herbert_C._Hoover_Building,_U.S._Department_of_Commerce,_Washington,_D.C_LCCN2010719591.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
